import React          from 'react';
import styled         from 'styled-components';
import { History }    from 'history';
import { INavItem }   from '@utils/navigation';
import { HeaderMenu } from './HeaderMenu';

const HeaderWrapper = styled.div`
  display          : flex;
  justify-content  : space-between;
  align-items      : center;
  position         : fixed;
  top              : 0;
  left             : 0;
  padding          : 12px 30px 8px;
  width            : 100%;
  height           : 64px;
  box-shadow       : 0 0 8px #C5C5C5;
  z-index          : 99;
  background-color : ${({ theme: { backgroundColor } }): string => backgroundColor.white};

  @media (min-width: 960px) {
    height  : 90px;
    padding : 16px 30px;
  }
`;

const HeaderActions = styled.div`
  display : flex;
  width   : 100%;

  @media (min-width: 960px) {
    flex-direction  : row;
    justify-content : flex-end;
  }
`;

interface IProps {
  history      : History;
  breadcrumbs? : INavItem[];
  isAuthorized : boolean;
  handleLogout : () => void;
  handleGoHome : () => void;
}

export const Header = ({
  history,
  breadcrumbs,
  isAuthorized,
  handleLogout,
  handleGoHome,
}: IProps): JSX.Element => (
  <HeaderWrapper>
    <HeaderActions>
      <HeaderMenu
        history      = {history}
        breadcrumbs  = {breadcrumbs}
        isAuthorized = {isAuthorized}
        handleLogout = {handleLogout}
        handleGoHome = {handleGoHome}
      />
    </HeaderActions>
  </HeaderWrapper>
);
